import React from 'react';
import { AuthState } from 'contexts/authContext';
import Storage from 'utils/storage';
import PermissionsService from 'services/permissionsService';

const initialState = {
  pageTitle: null,
  pageId: 0,
  isBackButtonVisible: true,
  area: {
    id: null,
    name: null
  },
  menu: {
    isRestricted: null,
    area: {
      id: null,
      name: null
    }
  },
  breadcrumb: [],
  theme: 'light-theme',
  lang: 'en',
  myViewsSection: 'AllViews',
};

const loadState = () => {
  try {
    const state = {
      pageTitle: initialState.pageTitle,
      pageId: initialState.pageId,
      isBackButtonVisible: initialState.isBackButtonVisible,
      area: initialState.area,
      menu: initialState.menu,
      breadcrumb: initialState.breadcrumb,
      theme: Storage.getString('appState.theme') != null ? Storage.getString('appState.theme') : initialState.theme,
      lang: Storage.getString('appState.lang') != null ? Storage.getString('appState.lang') : initialState.lang,
      myViewsSection: Storage.getString('appState.myViewsSection') != null ? Storage.getString('appState.myViewsSection') : initialState.myViewsSection
    };
    AppState = state;
    return state;
  } catch {
    AppState = initialState;
    return initialState;
  }
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET_AREA': {
      window.document.title = action.title || 'POSitouch Cloud';

      var pageId = state.pageId;
      /*if (state.area.id !== action.areaId) {
        pageId = 0;
        window.history.replaceState({ pageId: 0 }, '');
      }
      else*/
      if (window.history.state && window.history.state.pageId != null) {
        pageId = window.history.state.pageId;
      }
      else {
        window.history.replaceState({ pageId: pageId }, '');
      }

      return {
        ...state,
        pageTitle: action.title,
        pageId: pageId + 1,
        isBackButtonVisible: pageId > 0,
        area: {
          id: action.areaId,
          name: AppHelper.getAreaName(action.areaId),
        },
        menu: {
          ...state.menu,
          isRestricted: AuthState.isPortal,
          area: {
            id: (action.areaId === AppHelper.enums.AREAS.Account) ? null : action.areaId,
            name: (action.areaId === AppHelper.enums.AREAS.Account) ? null : AppHelper.getAreaName(action.areaId),
          },
        },
        breadcrumb: [],
      };
    }
    case 'SET_MENU': {
      return {
        ...state,
        menu: {
          ...state.menu,
          isRestricted: AuthState.isPortal,
          area: {
            id: action.areaId,
            name: AppHelper.getAreaName(action.areaId),
          },
        },
      };
    }
    case 'SET_BREADCRUMB': {
      return {
        ...state,
        breadcrumb: action.breadcrumb,
      };
    }
    case 'SET_LOGGED_IN': {
      return {
        ...initialState,
        pageId: 0,
      };
    }
    case 'SET_LANG': {
      Storage.setString('appState.lang', action.lang);
      return {
        ...state,
        lang: action.lang,
      };
    }
    case 'SET_MYVIEWSSECTION': {
      Storage.setString('appState.myViewsSection', action.myViewsSection);
      return {
        ...state,
        myViewsSection: action.myViewsSection,
      };
    }
    case 'SET_LOGGED_OUT': {
      return initialState;
    }
    case 'SET_THEME': {
      Storage.setString('appState.theme', action.theme);
      return {
        ...state,
        theme: action.theme,
      };
    }
    default:
      return state;
  }
}

//hack to use this store outside of components
export let AppState = initialState;
const reducerWrapper = (state, action) => {
  AppState = reducer(state, action);
  return AppState;
};

const AppContext = React.createContext();
export default AppContext;

export function AppContextProvider(props) {
  const [appState, dispatch] = React.useReducer(reducerWrapper, loadState());

  const setAppArea = (areaId, title) => {
    dispatch({
      type: 'SET_AREA',
      areaId: areaId,
      title: title
    });
  };

  const setAppMenu = (areaId) => {
    dispatch({
      type: 'SET_MENU',
      areaId: areaId
    });
  };

  const setAppBreadcrumb = (breadcrumb) => {
    dispatch({
      type: 'SET_BREADCRUMB',
      breadcrumb: breadcrumb
    });
  };

  const setAppLoggedIn = () => {
    dispatch({
      type: 'SET_LOGGED_IN'
    });
  };

  const setAppLoggedOut = () => {
    dispatch({
      type: 'SET_LOGGED_OUT'
    });
  };

  const setAppTheme = (theme) => {
    dispatch({
      type: 'SET_THEME',
      theme: theme
    });
  };

  const setAppLang = (lang) => {
    dispatch({
      type: 'SET_LANG',
      lang: lang
    });
  };

  const setMyViewsSection = (section) => {
    dispatch({
      type: 'SET_MYVIEWSSECTION',
      myViewsSection: section
    });
  };

  return (
    <AppContext.Provider value={{ appState, setAppArea, setAppMenu, setAppBreadcrumb, setAppLoggedIn, setAppLoggedOut, setAppTheme, setAppLang, setMyViewsSection }}>
      {props.children}
    </AppContext.Provider>
  );

}

export const AppHelper = {
  enums: {
    AREAS: PermissionsService.enums.AREAS,
  },

  getAreaName: function (area) {
    switch (area) {
      case this.enums.AREAS.Account:
        return 'Account';
      case this.enums.AREAS.SoftwareUpdate:
        return 'Software Update';
      case this.enums.AREAS.BackofficeReports:
        return 'Backoffice Reports';
      case this.enums.AREAS.SystemStatus:
        return 'System Status';
      case this.enums.AREAS.Views:
        return 'Views';
      case this.enums.AREAS.POSiConnect:
        return 'POSiConnect';
      case this.enums.AREAS.DataWarehouse:
        return 'Data Warehouse';
      case this.enums.AREAS.Menus:
        return 'Menus';
      case this.enums.AREAS.Employees:
        return 'Employees';
      case this.enums.AREAS.Boarding:
        return 'Boarding';
      default:
        return null;
    }
  },

  getAreaIcon: function (area) {
    switch (area) {
      default:
        return <></>;
    }
  }
};

AppContext.Areas = AppHelper.enums.AREAS;
